export default __webpack_public_path__ + "static/media/accounting-white-db.6246fc11.svg";